goog.provide('el8.service.pageunload');

/**
 * This service maintains a list of functions which will be run when
 * the page is being closed (bound to the onbeforeunload event).
 *
 * This is useful for things like saving dirty portions of a visit note
 * before the page is lost.
 */
el8.service.pageunload = (function() {

    var that = {};
    // Run if we're still logged in
    var fnList = [];
    // Run even if we're logged out
    var fnListLoginNotRequired = []

    function blurAll() {
        for (var i=0; i < fnList.length; i++) {
            fnList[i].call(that);
        }
        for (var i=0; i < fnListLoginNotRequired.length; i++) {
            fnListLoginNotRequired[i].call(that);
        }
    }

    $.extend(that, {

        init: function() {
            window.onbeforeunload = blurAll;
        },

        add: function(fn, loginRequired) {
            var isLoginRequired = loginRequired == null ? true : loginRequired;
            if (fn) {
                if (isLoginRequired) {
                  fnList.push(fn);
                }
                else {
                  fnListLoginNotRequired.push(fn);
                }
            }
        },

        /**
         * Useful when an event triggers an intentional page close.
         * For example, if we delete a patient, we don't want to attempt
         * to save any of the patient's documents while closing the page.
         */
        clearAll: function() {
            fnList = [];
            fnListLoginNotRequired = [];
        },

        clearLoginRequired: function() {
            fnList = [];
        }

    });

    return that;

})();
